import { createAction, props } from '@ngrx/store';

import { User } from './user.state.interface';

export const setUser = createAction('[User] Set authorized user', props<{ user: User | null }>());
export const logoutUser = createAction('[User] Logout authorized user');
export const clearUser = createAction('[User] Clear user data');